import React, { useEffect, lazy, useState }  from 'react';
import { apiMain } from '../../App';
import { GetDataPromise } from '../Functions/SendingData';
import { LoadingFull } from '../LoadingFull';
import { makeViewEvent, resetReachData, setMetaTags, updateOrgData, updateOrgDataBussiness, updateWebsiteData } from '../Functions/SetHeaders';

const Default = lazy(() => import('./Default'));
const ImageTop9 = lazy(() => import('./ImageTop9'));
const AboutusMain10 = lazy(() => import('./AboutusMain10'));
const TextBox11 = lazy(() => import('./TextBox11'));
const FullContact12 = lazy(() => import('./FullContact12'));
const ToursCarousel6 = lazy(() => import('./ToursCarousel6'));
const AgenciesCarousel4 = lazy(() => import('./AgenciesCarousel4'));
const SliderWSearch3 = lazy(() => import('./SliderWSearch3'));
const SliderNormal1 = lazy(() => import('./SliderNormal1'));
const ErrorPage13 = lazy(() => import('./ErrorPage13'));
const AgencyMain14 = lazy(() => import('./AgencyMain14'));
const TourMain16 = lazy(() => import('./TourMain16'));
const AgencyList15 = lazy(() => import('./AgencyList15'));
const TourList17 = lazy(() => import('./TourList17'));
const Banner4Main5 = lazy(() => import('./Banner4Main5'));
const BannerOneMain18 = lazy(() => import('./BannerOneMain18'));
const MetaTags19 = lazy(() => import('./MetaTags19'));
const HeaderWithTitle20 = lazy(() => import('./HeaderWithTitle20'));
const OnlySearchBar21 = lazy(() => import('./OnlySearchBar21'));
const Stages22 = lazy(() => import('./Stages22'));
const CtaInPage23 = lazy(() => import('./CtaInPage23'));
const FaqSmall24 = lazy(() => import('./FaqSmall24'));
const BannerWithTitle25 = lazy(() => import('./BannerWithTitle25'));
const BreadCrumb28 = lazy(() => import('./BreadCrumb28'));
const Continents26 = lazy(() => import('./Continents26'));
const BoxImages29 = lazy(() => import('./BoxImages29'));
const BoxImageText30 = lazy(() => import('./BoxImageText30'));
const Countries27 = lazy(() => import('./Countries27'));
const CtaTextInPage32 = lazy(() => import('./CtaTextInPage32'));
const InstallApp33 = lazy(() => import('./InstallApp33'));
const Pricing34 = lazy(() => import('./Pricing34'));
const CountryFilterBroker35 = lazy(() => import('./CountryFilterBroker35'));
const BrokerFilter36 = lazy(() => import("./BrokerFilter36"));
const BrokerMain37 = lazy(() => import('./BrokerMain37'));
const HotelsMain38 = lazy(() => import('./HotelsMain38'));
const InstallApp39 = lazy(() => import('./InstallApp39'));
const VideoPlayer40 = lazy(() => import('./VideoPlayer40'));
const CallSticky41 = lazy(() => import('./CallSticky41'));
const TypeWriterText42 = lazy(() => import('./TypeWriterText42'));
const VisaCountries43 = lazy(() => import('./VisaCountries43'));
const VisaCountry44 = lazy(() => import('./VisaCountry44'));

export default function PageBuilder (props){
  const { page , vars} = props;
  const [pageData, setPageData] = useState([]);
  const [pageDataMeta, setPageDataMeta] = useState([]);
  const [loading, setLoading] = useState(false);
  const [varsBase, setVarsBase] = useState({});
  useEffect(() => {
    getData();
  }, [])
  useEffect(() => {
    let check = false;
    if(!vars){
      return;
    }
    let keys = Object.keys(vars)
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if(varsBase[key] !== vars[key]){
        check = true;
      }
    }
    if(check) {
      setVarsBase(vars)
    }
  }, [vars])
  useEffect(() => {
    getData();
  }, [varsBase])
  const getData = async(force = false) => {
    resetReachData();
    if(page.search("home_web") !== -1){
      updateWebsiteData(props.lan.filename);
      updateOrgData(props.lan.filename);
    }
    if(page.search("travel_agency") !== -1 || page.search("luxintrip_operators") !== -1){
      updateOrgDataBussiness(props.lan.filename);
    }

    setLoading(true);
    let URLparams = new URLSearchParams();

    URLparams.append("Vi_Name", page)
    if(vars){
      let keys = Object.keys(vars);
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        URLparams.append(key, vars[key])
      }
    }

    let res = await GetDataPromise(`${apiMain}/api/v1/setting/views/select?${URLparams.toString()}`, force);
    let parsed = JSON.parse(res);


    if((parsed.status && parsed.status !== "error" && parsed.status !== "error-no-internet") || parsed.status === "success"){
      if(parsed.data.length){
        
        setPageData(parsed.data);
        setLoading(false);
        // if no ribbid 19 set default
        let dataList = parsed.data;
        if(dataList){
          let findIndex = dataList.findIndex((v) => parseInt(v.Ribb_Id) === 19);
          if (findIndex === -1) {
            setMetaTags("Luxintrip", "");
          }
          findIndex = dataList.findIndex((v) => parseInt(v.Ribb_Id) === 28);
          if(findIndex !== -1){
            setPageDataMeta((prev) => {
              return dataList[findIndex];
            });
          }
          let findIndexTour = dataList.findIndex((v) => parseInt(v.Ribb_Id) === 16);
          if(findIndexTour !== -1){
            setPageDataMeta((prev) => {
              return {
                ...prev,
                Tour: dataList[findIndexTour].Tour
              };
            });
          }
          let findIndexAgency = dataList.findIndex((v) => parseInt(v.Ribb_Id) === 37);
          if(findIndexAgency !== -1){
            setPageDataMeta((prev) => {
              return {
                ...prev,
                Agency: dataList[findIndexAgency].Agency
              };
            });
          }
          if(dataList.length){
            makeViewEvent(dataList[0].Vi_Code, JSON.stringify(vars))
          }
        }
        return;
      }
    }

    setPageData([
      {
        "Vi_Ribb_Id": 36,
        "Ribb_Id": 8,
        "Vi_Ribb_Data": "{}",
        "Vi_Ribb_Priority": 0,
      },
      {
        "Vi_Ribb_Id": 37,
        "Ribb_Id": 13,
        "Vi_Ribb_Data": "{}",
        "Vi_Ribb_Priority": 1,
      }
    ])
   setLoading(false);
}
  const tryJSON = (stringData) => {
    try {
      return JSON.parse(stringData);
    } catch (e) {
      return stringData;
    }
  }
  const makeRibbon = (data = {}, index) => {
   // console.log( data) 
    switch(data.Ribb_Id){
      case 1: 
        return (
          <SliderNormal1 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 3: 
        return (
          <SliderWSearch3 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 4:
        return (
          <AgenciesCarousel4
            {...props}
            key={data.Vi_Ribb_Id}
            data={data.Vi_Ribb_Data}
            list={data.Agency}
          />
        )
      case 5:
        return (
          <Banner4Main5 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 6:
        return (
          <ToursCarousel6
            {...props}
            key={data.Vi_Ribb_Id}
            data={data.Vi_Ribb_Data}
            list={data.Tour}
          />
        )
      case 8:
        return (
          <div className="navpad" key={data.Vi_Ribb_Id}></div>
        )
      case 9:
        return (
          <ImageTop9 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 10:
        return (
          <AboutusMain10 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 11:
        return (
          <TextBox11 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data} dataMain={pageDataMeta}/>
        )
      case 12:
        return (
          <FullContact12 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 13:
        return (
          <ErrorPage13 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 14:
        return (
          <AgencyMain14
            {...props}
            key={data.Vi_Ribb_Id}
            data={data.Vi_Ribb_Data}
            agency={data.Agency}
          />
        );
      case 15:
        return (
          <AgencyList15
            {...props}
            key={data.Vi_Ribb_Id}
            data={data.Vi_Ribb_Data}
          />
        )
      case 16:
        let newDetails = (data.Tour.DETAIL) ? data.Tour.DETAIL : [];
        for (let i = 0; i < newDetails.length; i++) {
          const element = newDetails[i];
          element.DESC = tryJSON(element.Tour_Det_Desc)
        }
        return (
          <TourMain16
            {...props}
            key={data.Vi_Ribb_Id}
            data={data.Vi_Ribb_Data}
            tour={{
              ...data.Tour,
              DETAIL: newDetails,
            }}
          />
        )
      case 17:
        return (
          <TourList17
            {...props}
            key={data.Vi_Ribb_Id}
            data={data.Vi_Ribb_Data}
            dataMain={pageDataMeta}
          />
        )
      case 18:
        return (
          <BannerOneMain18 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 19:
        return (
          <MetaTags19 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data} dataMain={pageDataMeta}/>
        )
      case 20:
        return (
          <HeaderWithTitle20 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data} dataMain={pageDataMeta}/>
        )
      case 21:
        return (
          <OnlySearchBar21 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 22:
        return (
          <Stages22 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 23:
        return (
          <CtaInPage23 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 24:
        return (
          <FaqSmall24 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 25:
        return (
          <BannerWithTitle25 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 26:
        return (
          <Continents26 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data} list={data.Continent}/>
        )
      case 27:
        return (
          <Countries27 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data} list={data.Country}/>
        )
      case 28:
        return (
          <BreadCrumb28 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data} dataMain={pageDataMeta}/>
        )
      case 29:
        return (
          <BoxImages29 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 30:
        return (
          <BoxImageText30 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 32:
        return (
          <CtaTextInPage32 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 33:
        return (
          <InstallApp33 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 34:
        return (
          <Pricing34 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 35:
        return (
          <CountryFilterBroker35 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 36:
        return (
          <BrokerFilter36
            {...props}
            key={data.Vi_Ribb_Id}
            data={data.Vi_Ribb_Data}
            pageDataMeta={pageDataMeta}
          />
        );
      case 37:
        return (
          <BrokerMain37
            {...props}
            key={data.Vi_Ribb_Id}
            data={data.Vi_Ribb_Data}
            agency={data.Agency}
          />
        );
      case 38:
        return (
          <HotelsMain38
            {...props}
            key={data.Vi_Ribb_Id}
            data={data.Vi_Ribb_Data}
            hotels={data.Hotels}
          />
        );
      case 39:
        return (
          <InstallApp39 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 40:
        return (
          <VideoPlayer40 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 41:
        return (
          <CallSticky41 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 42:
        return (
          <TypeWriterText42 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 43:
        return (
          <VisaCountries43 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 44:
        return (
          <VisaCountry44 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case "default":
        return (
          <Default {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      default:
        return "";
    }
  }
  const makePage = (data = []) => {
    return data.map((v, i) => {
      return makeRibbon(v, i)
    })
  }
  if(loading){
    return (
        <LoadingFull/>
    )
  }
  return (
    <>
      {makePage(pageData)}
    </>
  )
}

